export enum AccountTypeEnum {
  Coach = 'COACH',
  Athlete = 'ATHLETE',
}
